import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    cate = '',
    accessToken = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.common.uDictionary.getList, {
        cate,
        accessToken,
    }, options);
    if (error) return { error, status };
    return content || {};
};
